const IMAGE_MIME_TYPES = ['image/jpeg', 'image/jpg', 'image/png'];
const PDF_MIME_TYPES = ['application/pdf'];
export const PDF_IMG_MIME_TYPES = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'];
const EXTENSIONS_MIME_TYPE = {
  JPG: ['image/jpeg', 'image/jpg'],
  PNG: ['image/png'],
  PDF: ['application/pdf'],
};
const IMAGE_HEIGHT = 600;
const IMAGE_WIDTH = 600;
export {
  IMAGE_MIME_TYPES,
  PDF_MIME_TYPES,
  EXTENSIONS_MIME_TYPE,
  IMAGE_WIDTH,
  IMAGE_HEIGHT,
};
